<script>
import IconSearch from "../../../assets/icons/ic-search.svg";
import IconFiltre from "../../../assets/icons/ic-filtre.svg";
import radio from "../../helper/form/radio.vue";
import icKa from "../../../assets/icons/ic-ka.svg";
import Tel from "../../../assets/icons/ic-telephone.svg";
import { getServiceRequest } from "@/component/cdevs/allFunctions";
import requestLists from "./requestLists.vue";
import detailsRequest from "./detailsRequest.vue";
import multiselect from "@/component/helper/form/multiselect";

export default {
  name: "AllCharteredAccountant",
  components: { requestLists, radio, detailsRequest, multiselect },
  data() {
    return {
      icons: { IconSearch, IconFiltre, icKa, Tel },
      all_request: [],
      charge: false,
      empty: false,
      limit: 1000,
      page: 1,
      search: "",
      timer: null,
      isDetail: false,
      oneDetail: null,
      allState: ["TOUS", "EN ATTENTE", "TRAITÉ"],
      filter: "TOUS",
    };
  },

  created() {
    this.getAllServiceRequest(this.limit, this.page, this.search, this.filter);
  },

  methods: {
    refresh(){
     this.getAllServiceRequest(this.limit, this.page, this.search);
    },

    cleanObject(obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([_, value]) => value !== null && value !== undefined && value !== ""
        )
      );
    },

    sendType(a) {
      if (a === "EN ATTENTE") {
        this.filter = "WAITING";
      } else if (a === "TRAITÉ") {
        this.filter = "TREATED";
      } else {
        this.filter = "TOUS";
      }
      this.getAllServiceRequest(
        this.limit,
        this.page,
        this.search,
        this.filter
      );
    },

    /* Function to get all chartered accountant */
    async getAllServiceRequest(limit, page, search, state) {
      this.charge = true;
      const data = {
        apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
        limit: limit,
        page: page,
        search: search,
        state: state,
      };

      if (this.filter === "TOUS") {
        delete data.state;
      }
      if (!this.search) {
        delete data.search;
      }
      // this.cleanObject(data);
    await getServiceRequest(data)
      .then((response) => {
        console.log(response);
        this.all_request = response.data;
          this.charge = false;
      });
    },

    openDetail(val) {
      this.isDetail = true;
      this.oneDetail = val;
    },

    closeDetail(value) {
      if (value) {
        this.getAllServiceRequest(
          this.limit,
          this.page,
          this.search,
          this.filter
        );
      }
      this.isDetail = false;
    },
    selected(item) {
      this.$store.dispatch("saveCompany", item.company);
      this.$router.push("commerceDetail");
    },
  },

  watch: {
    search(newValue) {
      if (this.timer) {
        clearTimeout(this.timer); // Annuler le précédent timeout
      }

      this.timer = setTimeout(() => {
        this.getAllServiceRequest(this.limit, this.page, newValue, this.filter);
      }, 300); // Exécuter après 300ms d'inactivité
    },
  },
};
</script>

<template>
  <div class="">
    <div class="flex justify-start responsive-container">
      <div class="flex items-center justify-start gap-5">
        <div
          class="flex items-center justify-start border border-gray py-2 rounded-100"
        >
          <icon
            :data="icons.IconSearch"
            height="20"
            width="20"
            class="w-5 h-5 mx-4"
            original
          />
          <input
            v-model="search"
            type="text"
            class="text-c16 responsive-input rounded-100"
            placeholder="Rechercher"
          >
        </div>
        <div>
          <multiselect
            :value-t="allState[0]"
            :option="allState"
            @info="sendType"
            height="42px"
            radius="8px"
            size="16px"
            background="#FFF"
            border="1px solid #EDEDEE"
          />
        </div>
      </div>
    </div>

    <div class="responsive-container">
      <div
        class="backg w-full flex items-center TextColor h-14 px-5 rounded-t-10 mt-5"
      >
        <div class="flex items-center gap-5 w-1/2">
          <radio />
          <div>Entreprise</div>
        </div>
        <div class="w-1/2 flex justify-start">
          Service demandé
        </div>
        <div class="w-1/3 flex justify-start">
          Date de demande
        </div>
        <div class="w-1/3 flex justify-start">
          Date du besoin
        </div>
        <div class="w-1/4 flex justify-start pl-10">
          Statut
        </div>
      </div>

      <div
        v-if="charge"
        class="flex justify-center mt-16"
      >
        <easy-spinner
          type="dots"
          size="70"
        />
      </div>

      <div
        class="text-center my-10"
        v-if="all_request.length === 0"
      >
        Aucune demande de service pour le moment
      </div>

      <div class="w-full">
        <requestLists
          v-for="(item, i) in all_request"
          :key="i"
          :one-request="item"
          @selected="selected"
          @refresh="refresh"
        />
      </div>
    </div>
    <!-- Details Request service -->
    <div v-if="isDetail">
      <detailsRequest
        @closeDetail="closeDetail"
        :one-detail="oneDetail"
      />
    </div>
  </div>
</template>

<style>
.backg {
  background-color: #eff5f9;
}
.TextColor {
  color: #6b6b75;
  font-size: 16px;
  line-height: 18px;
  font-weight: 400;
}
.BorderColor {
  border-bottom: 1px solid #e7eef8;
}
.listeStyle {
  font-weight: 400;
  font-size: 18px;
}
.Email {
  color: #6aa3f2;
}
</style>
